import { api } from '../axios'
import type { ApiResponse, SchoolType } from '../../../types'

export const schoolTypesApi = {
  getAll: () =>
    api.get<ApiResponse<SchoolType[]>>('/school-types'),

  getAllIncludingInactive: () =>
    api.get<ApiResponse<SchoolType[]>>('/school-types/all'),

  getActive: () =>
    api.get<ApiResponse<SchoolType[]>>('/school-types/active'),

  getById: (id: number) =>
    api.get<ApiResponse<SchoolType>>(`/school-types/${id}`),

  create: (data: SchoolType) =>
    api.post<ApiResponse<SchoolType>>('/school-types', data),

  update: (id: number, data: Partial<SchoolType>) =>
    api.put<ApiResponse<SchoolType>>(`/school-types/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/school-types/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/school-types/${id}/permanent`),
}

